import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

import {
  MDBIcon,
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane,
  MDBContainer,
  MDBCol,
  MDBRow,
  MDBBtn,
  MDBInput,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
} from 'mdb-react-ui-kit';
import Helper from '../Helper';
import Navbar from './sub/navbar';

import moment from 'moment';
import Alert from './sub/dialog'
import DashboardCustomer from './sub/DashboardCustomer';
import DashboardJob from './sub/DashboardJob';

const MainPage = () => {
  const navigate = useNavigate();
  const alert = useRef();
  useEffect(() => {
    // Get the token from sessionStorage


    if (!Helper.gettoken()) {
      navigate('/login');
      return;
    }

    if (!["admin"].includes(Helper.getuserrole())) {
      navigate('/main');
      return;
    }

  }, []);
  const [iconsActive, setIconsActive] = useState('perjob');

  const handleIconsClick = (value) => {
    if (value === iconsActive) {
      return;
    }

    setIconsActive(value);
  };
  return (
    <>
      <Navbar />
      <MDBContainer fluid className="my-3">
        <Alert ref={alert} />

        <MDBRow className="justify-content-center">
          <MDBCol md="12">
            <MDBCard className="shadow-4 rounded-5">
              <MDBCardHeader>
                <MDBRow className='bg-body-tertiary d-flex align-items-center'>
                  <MDBCol md='10'>
                    <h4>ภาพรวม</h4>
                  </MDBCol>

                </MDBRow>


              </MDBCardHeader>
              <MDBCardBody>

                <MDBTabs className='mb-3'>
                  <MDBTabsItem>
                    <MDBTabsLink onClick={() => handleIconsClick('perjob')} active={iconsActive === 'perjob'}>
                      <MDBIcon fas icon='file' className='me-2' /> ภาพรวมราย Job
                    </MDBTabsLink>
                  </MDBTabsItem>
                  <MDBTabsItem>
                    <MDBTabsLink onClick={() => handleIconsClick('percustomer')} active={iconsActive === 'percustomer'}>
                      <MDBIcon fas icon='user' className='me-2' /> ภาพรวมรายลูกค้า
                    </MDBTabsLink>
                  </MDBTabsItem>
                </MDBTabs>

                <MDBTabsContent>
                  <MDBTabsPane open={iconsActive === 'perjob'}>
                    <DashboardJob />

                  </MDBTabsPane>
                  <MDBTabsPane open={iconsActive === 'percustomer'}>

                    <DashboardCustomer />
                  </MDBTabsPane>

                </MDBTabsContent>

              </MDBCardBody>

            </MDBCard>
          </MDBCol>
        </MDBRow>



      </MDBContainer>

    </>
  );
};

export default MainPage;
